import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { DeepReactive } from '@jack-henry/frontend-utils/lit';
import { CreditorsService, IntermediaryBank, WireCreditor } from '@treasury/domain/wires';
import { TmBaseComponent } from '@treasury/presentation';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import './creditor-data-editable';

export const tagName = 'creditor-create-step';
@customElement(tagName)
export class CreditorCreateStep extends TmBaseComponent {
    @property({ attribute: false })
    private creditor?: WireCreditor;

    @InjectProperty()
    declare private creditorsService: CreditorsService;

    @DeepReactive()
    private validState = {
        agentId: false,
        validAgentId: false,
        agentName: false,
        agentCity: false,
        agentState: false,
        accountNumber: false,
        accountMatch: false,
        name: false,
        country: false,
        city: false,
        instructedAgent: true,
    };

    @state()
    private hasValidInstructedAgent = false;

    @state()
    private isValidIntermediaryAgent = true;

    protected render() {
        return html`<creditor-data-editable
                .creditor=${this.creditor}
                @update=${({ detail }: CustomEvent) => {
                    this.creditor = detail.creditor;
                    this.validState.instructedAgent = detail.validInstructedAgentState;
                    this.hasValidInstructedAgent = detail.hasValidInstructedAgent;
                    this.checkValidState();
                }}
                @account-match=${({ detail }: CustomEvent) => {
                    this.validState.accountMatch = detail;
                }}
            ></creditor-data-editable>
            <tm-footer
                .buttonConfig=${[
                    {
                        text: 'Review',
                        disabled:
                            Object.values(this.validState).some(isValid => !isValid) ||
                            !this.isValidIntermediaryAgent,
                        onClick: () => {
                            this.dispatchEvent(
                                new CustomEvent('review', { detail: this.creditor })
                            );
                        },
                    },
                ]}
            ></tm-footer>`;
    }

    private checkValidState() {
        if (this.creditor) {
            this.validState.agentId = !!this.creditor.bank?.bankId;
            if (this.creditor.bank?.bankId && !this.hasValidInstructedAgent) {
                this.validState.validAgentId = this.creditorsService.validateAgentId(
                    this.creditor.bank.bankId
                );
            } else {
                this.validState.validAgentId = true;
            }
            this.validState.agentName = !!this.creditor.bank?.name;
            this.validState.agentCity = !!this.creditor.bank?.city;
            if (this.creditor.isInternational) {
                this.validState.agentState = true;
            } else {
                this.validState.agentState =
                    this.creditor.bank?.state === ' ' ? false : !!this.creditor.bank?.state;
            }
            this.validState.accountNumber = !!this.creditor.accountNumber;
            this.validState.name = !!this.creditor.name;
            this.validState.country = !!this.creditor.country;
            this.validState.city = !!this.creditor.city;

            this.isValidIntermediaryAgent = true;
            this.creditor.intermediaryBanks?.forEach(bank => {
                const intermediaryBank = new IntermediaryBank(bank);
                this.isValidIntermediaryAgent = intermediaryBank.isValid();
            });
        }
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: CreditorCreateStep;
    }
}
